__turbopack_context__.v({
  "addressActions": "account-details-module__LcBSYW__addressActions",
  "addressCard": "account-details-module__LcBSYW__addressCard",
  "addressForm": "account-details-module__LcBSYW__addressForm",
  "button": "account-details-module__LcBSYW__button",
  "credit": "account-details-module__LcBSYW__credit",
  "debit": "account-details-module__LcBSYW__debit",
  "defaultCheck": "account-details-module__LcBSYW__defaultCheck",
  "error": "account-details-module__LcBSYW__error",
  "full": "account-details-module__LcBSYW__full",
  "grid": "account-details-module__LcBSYW__grid",
  "hint": "account-details-module__LcBSYW__hint",
  "ledger": "account-details-module__LcBSYW__ledger",
  "ledgerRow": "account-details-module__LcBSYW__ledgerRow",
  "notice": "account-details-module__LcBSYW__notice",
  "panel": "account-details-module__LcBSYW__panel",
  "profileForm": "account-details-module__LcBSYW__profileForm",
  "regionList": "account-details-module__LcBSYW__regionList",
  "regionSummary": "account-details-module__LcBSYW__regionSummary",
  "secondary": "account-details-module__LcBSYW__secondary",
  "sectionHeading": "account-details-module__LcBSYW__sectionHeading",
  "walletHeading": "account-details-module__LcBSYW__walletHeading",
});
